import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Hero from './components/Hero';
import Features from './components/Features';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import Support from './components/Support';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Downloads from './components/Downloads';
import Releases from './components/Releases';
import DemoVideo from './components/DemoVideo';
import WalkthroughVideo from './components/WalkthroughVideo';
import Navigation from './components/Navigation';
import SEO from './components/SEO';
import { initGA } from './utils/analytics';

// Home page component
const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO />
      <Navigation 
        trackingLocation="homepage"
      />
      <Hero />
      <Features />
      <CallToAction />
    </>
  );
};

function App() {
  useEffect(() => {
    // Initialize GA (ensures it's ready for tracking)
    initGA();
  }, []);

  // Check if we're in staging/dev and should block indexing
  const noindex = process.env.REACT_APP_ROBOTS_INDEX !== 'true';

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/demo" element={<><SEO noindex={noindex} /><DemoVideo /></>} />
            <Route path="/walkthrough/:id" element={<><SEO noindex={noindex} /><WalkthroughVideo /></>} />
            <Route path="/support" element={<><SEO noindex={noindex} /><Support /></>} />
            <Route path="/privacy" element={<><SEO noindex={noindex} /><PrivacyPolicy /></>} />
            <Route path="/terms" element={<><SEO noindex={noindex} /><TermsOfService /></>} />
            <Route path="/downloads" element={<><SEO noindex={noindex} /><Downloads /></>} />
            <Route path="/releases" element={<><SEO noindex={noindex} /><Releases /></>} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;